module.exports = __webpack_public_path__ + "img/l.08eea24a.png";